export const OWNER = 'owner';
export const SHARED = 'shared';
export const PRIVATE = 'private';
export const RESTRICTED = 'restricted';
export const PUBLIC = 'public';
export const FRONT_COVER = 'front_cover.jpg';
export const INNER_FRONT_COVER = 'inner_front_cover.jpg';
export const BACK_COVER = 'back_cover.jpg';
export const INNER_BACK_COVER = 'inner_back_cover.jpg';
export const WHITE_BG = 'white_bg.jpg';
export const VIEWER_TYPE_OWNER = 'Owner';
export const VIEWER_TYPE_VISITOR = 'Visitor';



// WEBPACK FOOTER //
// ./src/Account/EPhotobook/Constants.js